export enum AttributeDataType
{
    FIXED_VALUES = 'FIXED_VALUES',
    INTEGER = 'INTEGER',
    DECIMAL = 'DECIMAL',
    TEXT = 'TEXT'
}
